import React from "react"

const SharedAgencyCodesContext = React.createContext({})

const { Provider, Consumer } = SharedAgencyCodesContext

export { Provider, Consumer, SharedAgencyCodesContext }
